import useSWR from 'swr';
import { fetchDocBySlug, fetchDocs, fetchNavigation } from '../api/docs';

export const useNav = () => useSWR('nav', fetchNavigation, { revalidateOnFocus: false });

export const useDocs = () => useSWR('docs', fetchDocs, { revalidateOnFocus: false });

export const useDoc = (slug?: string) =>
  useSWR(slug ? ['doc', slug] : null, () => fetchDocBySlug(slug!), {
    revalidateOnFocus: false
  });

